module.exports = __webpack_public_path__ + "img/img-jili-fish-s.df8783cc.png";